export type InspectionStatus = (typeof InspectionStatuses)[keyof typeof InspectionStatuses];

export const InspectionStatuses = {
  UNSCHEDULED: "unscheduled",
  SCHEDULED: "scheduled",
  PASSED: "passed",
  FAILED: "failed",
  REQUESTED: "requested",
  STARTED: "started",
} as const;
